module.exports = __webpack_public_path__ + "static/Gotham-MediumItalic-d9d404a95d864634fc78f6ba5889ecd3.woff";